// src/modules/app-views/_apps/appmulti/plans/pages/Document/decorators/response.js
// *******************************************************************************
// RESPONSE DECORATOR
// Transforms data received from the server before binding to form
// *******************************************************************************

/**
 * Transforms server response before binding to form components
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.doc - Single document (used when mapping arrays)
 * @param {Object|Array} ctx.payload - Complete payload from server
 * @param {Object} ctx.summary - Summary data from response
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for form binding
 */
const decorateResponse = ctx => {
  const { doc } = ctx;

  if (!doc) return doc;

  const transformed = { ...doc };

  // Flatten grievance nested objects to flat form fields
  // grievance1: { minAge, maxAge, addition } → grievanceMinAge1, grievanceMaxAge1, grievanceAdditionAge1
  if (doc.grievance1) {
    transformed.grievanceMinAge1 = doc.grievance1.minAge;
    transformed.grievanceMaxAge1 = doc.grievance1.maxAge;
    transformed.grievanceAdditionAge1 = doc.grievance1.addition;
  }

  if (doc.grievance2) {
    transformed.grievanceMinAge2 = doc.grievance2.minAge;
    transformed.grievanceMaxAge2 = doc.grievance2.maxAge;
    transformed.grievanceAdditionAge2 = doc.grievance2.addition;
  }

  if (doc.grievance3) {
    transformed.grievanceMinAge3 = doc.grievance3.minAge;
    transformed.grievanceMaxAge3 = doc.grievance3.maxAge;
    transformed.grievanceAdditionAge3 = doc.grievance3.addition;
  }

  // Transform destinations array to checkbox map
  // ['south_america', 'europe'] → { __destinations: { south_america: true, europe: true } }
  if (Array.isArray(doc.destinations)) {
    const destinationsMap = {};
    for (const dest of doc.destinations) {
      destinationsMap[dest] = true;
    }
    transformed.__destinations = destinationsMap;
  }

  // Transform travelProfiles array to checkbox map
  // ['tourism', 'sports'] → { __travelProfiles: { tourism: true, sports: true } }
  if (Array.isArray(doc.travelProfiles)) {
    const profilesMap = {};
    for (const profile of doc.travelProfiles) {
      profilesMap[profile] = true;
    }
    transformed.__travelProfiles = profilesMap;
  }

  return transformed;
};

export default decorateResponse;
